/*---- Page constants----------------------------*/
export const INTRODUCTION = "introduction"
// export const BESTPRACTICE = "bestPractice"
export const HOME = "home"
export const INTRO_TITLE = "AllAboutMe Resources"
export const TECHNICAL = "technical"
export const TECHNICAL_TITLE = "Technical"
export const TERM = "term"
export const TERM_TITLE = "Conditions"
export const HANDOVER = "handoverhandback"
export const HANDOVER_TITLE = "Handover and Handback"
export const IMG_DELIVERY = "imagedelivery"
export const IMG_DELIVERY_TITLE = "Image Delivery Web Service"
export const IMG_DELIVERY2 = "imagedelivery2"
export const IMG_DELIVERY2_TITLE = "Image Delivery 2 Web Service"
export const GET_IMAGE = "getimage"
export const GET_IMAGE_TITLE = "GetImage"
export const GET_NEXT_IMAGE = "getnextimage"
export const GET_NEXT_IMAGE_TITLE = "GetNextImage"
export const SEND_RECEIPT = "sendreceipt"
export const SEND_RECEIPT_TITLE = "SendReceipt"
export const IMAGE_INFORMATION = "Image Information Web Service"
export const IMAGE_INFORMATION_ROUTE = "imageinformation"
export const IMAGE_INFORMATION_TITLE = "Image Information Web Service"
export const IMAGE_INFORMATION_v1 = "Image Information Web Service (Original)"
export const IMAGE_INFORMATION_V1_ROUTE = "imageinformationv1"
export const IMAGE_INFORMATION_V1_TITLE = "Image Information Web Service (Original)"
export const IMAGE_INFORMATION_V2_ROUTE = "imageinformationv2"
export const IMAGE_INFORMATION_V2_TITLE = "Image Information Web Service (Version 2)"
export const SET_TRANSACTION_APPROVAL_STATE_V2 = "settransactionapprovalstatev2"
export const SET_TRANSACTION_APPROVAL_STATE_V2_TITLE = "Set Transaction Approval State"
export const IMAGE_INFORMATION_V3_ROUTE = "imageinformationv3"
export const IMAGE_INFORMATION_V3_TITLE = "ImageInformation"
export const IMAGE_INFORMATION_V4_ROUTE = "imageinformationv4"
export const SET_CUSTOM_DATA_CAPTURE = "setcustomdatacapture"
export const SET_CUSTOM_DATA_CAPTURE_TITLE = "SetCustomDataCapture"
export const SET_EMAIL_ADDRESS = "setemailaddress"
export const SET_EMAIL_ADDRESS_TITLE = "SetEmailAddress"
export const SET_TRANSACTION_APPROVAL_STATE_V3 = "settransactionapprovalstate"
export const SET_TRANSACTION_APPROVAL_STATE_TITLE = "SetTransactionApprovalState"
export const SET_PRODUCT_SWAP = "setproductswap"
export const SET_PRODUCT_SWAP_TITLE = "SetProductSwap"
export const GALLERY_API = "galleryapi"
export const GALLERY_API_TITLE = "Gallery API"
export const ECHO = "echo"
export const ECHO_TITLE = "pcs.echo"
export const GET_CATEGORY_LIST = "getcategorylist"
export const GET_CATEGORY_LIST_TITLE = "pcs.get_category_list"
export const GET_CATEGORY_COUNT = "getcategorycount"
export const GET_CATEGORY_COUNT_TITLE = "pcs.get_category_count"
export const GET_CATEGORY_IMAGE_LIST = "getcategoryimagelist"
export const GET_CATEGORY_IMAGE_LIST_TITLE = "pcs.get_category_image_list"
export const GET_CATEGORY_IMAGE_COUNT = "getcategoryimagecount"
export const GET_CATEGORY_IMAGE_COUNT_TITLE = "pcs.get_category_image_count"
export const SEARCH_IMAGES = "searchimages"
export const SEARCH_IMAGES_TITLE = "pcs.search_images"
export const CREATE_GALLERY_CARD = "creategallerycard"
export const CREATE_GALLERY_CARD_TITLE = "pcs.create_gallery_card"
export const DATA_CAPTURE_MATCHING_HANDLER = "datacapturematchinghandler"
export const DATA_CAPTURE_MATCHING_HANDLER_TITLE = "Data Capture Matching Handler"
export const STEPBYSTEP = "stepByStep"
export const STEPBYSTEP_TITLE = "Step By Step"
export const AAM_NEW_PROGRAM_GUIDE = "AAMNewProgramGuide"
export const AAM_NEW_PROGRAM_GUIDE_TITLE = "AAM New Program Guide"
export const AAM_GALLERY_SETUP_GUIDE = "AAMgallerysetup"
export const AAM_GALLERY_SETUP_GUIDE_TITLE = "AAM Gallery Setup"
export const PUBLIC_DESIGN_HANDLER = "publicdesignhandler"
export const PUBLIC_DESIGN_HANDLER_TITLE = "Public Design Handler"
export const COMPETITION_API = "competitionapi"
export const COMPETITION_API_TITLE = "Competition API"
export const ADD_VOTE = "addvote"
export const ADD_VOTE_TITLE = "allaboutme.pcs.add_vote"
export const GET_CAPTCHA = "getcaptcha"
export const GET_CAPTCHA_TITLE = "allaboutme.pcs.get_captcha"
export const GET_DESIGN = "getdesign"
export const GET_DESIGN_TITLE = "allaboutme.pcs.get_design"
export const GET_DESIGN_COUNT = "getdesigncount"
export const GET_DESIGN_COUNT_TITLE = "allaboutme.pcs.get_design_count"
export const GET_DESIGN_LIST = "getdesignlist"
export const GET_DESIGN_LIST_TITLE = "allaboutme.pcs.get_design_list"
export const GET_TOP_VOTED = "gettopvoted"
export const GET_TOP_VOTED_TITLE = "allaboutme.pcs.get_top_voted"
export const SET_PUBLIC_DESIGN = "setpublicdesign"
export const SET_PUBLIC_DESIGN_TITLE = "allaboutme.pcs.set_public_design"
export const AAM_USER_MANAGEMENT = "AAMUserManagement"
export const AAM_USER_MANAGEMENT_TITLE = "AAM User Management"
export const IMAGE_SHARE_GUIDE="imageshareguide"
export const IMAGE_SHARE_GUIDE_TITLE="ImageShare Guide"
export const IMAGE_DELIVERY_SCRIPT="imagedeliveryscript"
export const IMAGE_DELIVERY_SCRIPT_TITLE="Image Delivery Script"
export const REPORTING_GUIDE="AAMReporting"
export const REPORTING_GUIDE_TITLE="AAM Reporting"
export const IMAGECHECKING_GUIDE="AAMImageCheckingGuide"
export const IMAGECHECKING_GUIDE_TITLE="AAM Image Checking Guide"
export const APPEALS_PROCESS="AppealsProcess"
export const APPEALS_PROCESS_TITLE="Appeals Process"
export const ClipArt_Gallery="ClipArtGallery"
export const ClipArt_Gallery_TITLE="ClipArt Gallery"
export const Image_Validator="ImageValidator"
export const Image_Validator_TITLE="Image Validator"
export const Upload_Image="uploadimage"
export const Upload_Image_TITLE="Upload Image Web Service"
export const SEND_IMAGE="sendimage"
export const SEND_IMAGE_TITLE="SendImage"
export const SEND_IMAGE_DATA_CAPTURE="sendImageWithDataCapture"
export const SEND_IMAGE_DATA_CAPTURE_TITLE="SendImageWithDataCapture"
export const HTML_PLUGIN_INTEGRATION="htmlPluginIntegration"
export const HTML_PLUGIN_INTEGRATION_TITLE="HTML5 Plugin Integration Guide"
export const IMAGE_HUB="imagehub"
export const IMAGE_HUB_TITLE="Image Hub Documentation"
export const SIGNATUREONCARD="SignatureOnCard"
export const SIGNATUREONCARD_TITLE="Signature On Card"
export const SAMLSSO="samlSSO"
export const SAMLSSO_TITLE="SAML SSO Documentation"
export const IMG_PURGE = "imagepurge"
export const IMG_PURGE_TITLE = "Image Purge Web Service"
export const SET_IMAGE_TO_PURGE="setimagetopurge"
export const SET_IMAGE_TO_PURGE_TITLE="SetImageToPurge"

/*---- Page constants end----------------------------*/